import React from "react";
import {
  SignalIcon,
  GatewayIcon,
  DistanceSensorIcon,
  LightSensorIcon,
  GasSensorIcon,
  VibrationSensorIcon,
  HumiditySensorIcon,
  TemperatureSensorIcon,
} from "../components/Common/icons/device";

export enum DeviceIconId {
  Signal = 0,
  Gateway = 1,
  ArrowUpDown = 2,
  Sun = 3,
  Flame = 4,
  Wave = 5,
  Humidity = 6,
  Thermo = 7,
}

export type DeviceIconConfig = {
  id: DeviceIconId;
  label: string;
  icon: React.ComponentType<any>;
};

export const deviceIcons: DeviceIconConfig[] = [
  { id: DeviceIconId.Signal, label: "Default", icon: SignalIcon },
  { id: DeviceIconId.Gateway, label: "Gateway", icon: GatewayIcon },
  { id: DeviceIconId.ArrowUpDown, label: "Distance Sensor", icon: DistanceSensorIcon },
  { id: DeviceIconId.Sun, label: "Light Sensor", icon: LightSensorIcon },
  { id: DeviceIconId.Flame, label: "Gas Sensor", icon: GasSensorIcon },
  { id: DeviceIconId.Wave, label: "Vibration Sensor", icon: VibrationSensorIcon },
  { id: DeviceIconId.Humidity, label: "Humidity Sensor", icon: HumiditySensorIcon },
  { id: DeviceIconId.Thermo, label: "Temperature Sensor", icon: TemperatureSensorIcon },
];

export const getDeviceIcon = (iconId: number): React.ComponentType<any> => {
  const config = deviceIcons.find((d) => d.id === iconId);
  return config?.icon ?? SignalIcon;
};
